export const getTreeTargetData = (treeData, id, idKey) => {
    let targetData = null;
    const forEachData = list => {
        for (let i in list) {
            const item = list[i];
            if (item[idKey] === id) {
                targetData = item;
                return;
            }
            if (item.children) {
                forEachData(item.children);
            }
        }
    };
    forEachData(treeData);
    return targetData;
};
